import { bunja } from 'bunja';
import { atom } from 'jotai';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import { formBunja } from './form';
import { formSegmentDataBunja } from './form-segment-data';

export const priceFormSegmentBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const formBunjaInstnace = bunja.use(formBunja);
  const formSegmentDataBunjaInstance = bunja.use(formSegmentDataBunja);
  const { triggerPriceAtom } = formBunjaInstnace;
  const { symbol, leverageAtom, orderByTokenAtom, orderTypeAtom, positionModeAtom } = formSegmentDataBunjaInstance;

  const tabPriceClearClickParamsAtom = atom((get) => {
    const leverage = get(leverageAtom);
    const orderByToken = get(orderByTokenAtom);
    const orderType = get(orderTypeAtom);
    const positionMode = get(positionModeAtom);
    const triggerPrice = get(triggerPriceAtom);
    return {
      position_mode: positionMode,
      symbol,
      leverage,
      order_type: orderType,
      order_by_token: orderByToken,
      set_price: Number(triggerPrice || '0'),
    };
  });

  function trackTabPriceClearClick() {
    segment.track(TradeEvent.TabPriceClearClick, store.get(tabPriceClearClickParamsAtom));
  }

  function trackTabPriceEditClick() {
    segment.track(TradeEvent.TabPriceEditClick, store.get(tabPriceClearClickParamsAtom));
  }

  return {
    tabPriceClearClickParamsAtom,
    trackTabPriceClearClick,
    trackTabPriceEditClick,
  };
});
priceFormSegmentBunja.debugLabel = 'priceFormSegmentBunja';
